/*jshint esversion: 6 */
import React, { Component } from 'react';
import './css/App.css';
import HeadGuider from './Components/PageHead';
import Footer from './Components/PageFooter';
import AppRoutes from './AppRoutes';

import * as pageGetter from "./Controllers/PageGetter.js";
import * as templateGetter from "./Controllers/TemplateGetter.js";
import * as paragraphGetter from "./Controllers/ParagraphGetter.js";
import * as manusGetter from "./Controllers/ManusGetter.js";
import * as strFuncs from "./utils/stringFuncs.js";


  class App extends Component {
    constructor(props){
      super(props);
      this.state = {
        pages: [],
        footer: [],
        templates: [],
        paragraphs: [],
        manuses: [],
        isMobileToggleOn: false
    };
    this.getHierarchicalPageTitles = this.getHierarchicalPageTitles.bind(this);
  }

  componentWillMount(){
    pageGetter.getAllPages_SeparatelyFooter(this);
    templateGetter.getAllTemplates(this);
    manusGetter.getAllManus(this);
    paragraphGetter.getParagraphs(this);
  }


/*   
  getPageTitles = () =>{
      let pages = this.state.pages.slice();
      //console.log('getPageTitles pages ', pages);
      let pageTitles = [];
      pages.map(p => {
        pageTitles.push(p.pagetitle);
      });

      //console.log('getPageTitles pageTitles ', pageTitles);
      return pageTitles;
  }
 */

  getHierarchicalPageTitles(){
    let pages = this.state.pages.slice();
    let spages = this.state.pages.slice();
    //console.log('getPageTitles pages ', pages);
    let hTitles = [];
    let subPagesValidation = [];
    pages.forEach(p => {
      let _parent = p.pagetitle;
      let _link = '/' + strFuncs.replaceSymbols(p.pagetitle);
      let _subpages = spages.filter(s => p.subpages.includes(s._id)).map(sp => sp.pagetitle);
      subPagesValidation = subPagesValidation.concat(_subpages);
      
      
      if(!subPagesValidation.includes(_parent)){

        let _subpagess = _subpages.slice();
        let subbs = _subpagess.map(sp =>{
          return ({
            title : sp,
            link: _link + '/#' + strFuncs.replaceSymbols(sp)
          });
        });

        let newRelation = {
          parent : _parent,
          subpages : subbs,
          link: _link};
          hTitles.push(newRelation);
      }
    })
    console.log('getPageTitles pageTitles ', hTitles);
    return hTitles;
  }



  render() {
    // let fp = this.state.footerParagraphs.slice();
    // console.log('RENDER  STATE footerParagraphs', fp);
    const templates = this.state.templates.slice();
    const pageObjects = this.state.pages.slice();
    const footerObjects = this.state.footer.slice();
    const paragraphs = this.state.paragraphs.slice();
    const manuses = this.state.manuses.slice();
    const pagetitles = this.getHierarchicalPageTitles();
    console.log('RENDER app.js  pagetitles', pagetitles);
    return (
      <div className="App">
        <div id="head">
            <HeadGuider 
              pagetitles = {pagetitles}
              templates = {templates}
            />
        </div>
        <div id="body">
          <AppRoutes 
              pagetitles = {pagetitles}
              pageObjects = {pageObjects}
              templates = {templates}
              paragraphs = {paragraphs}
              manuses = {manuses}
          />
        </div>

       <footer>
          <Footer
            pagetitles = {pagetitles}
            footer =  {footerObjects}
            templates = {templates}
            paragraphs = {paragraphs}
            manuses = {manuses}
          />
        </footer>
        
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js